import { MenuItemProps, MenuItem } from "@mui/material";

const BaseSelectItem = (props: MenuItemProps) => {
  return (
    <MenuItem sx={{ display: "flex", alignItems: "center", gap: "8px" }} {...props}>
      {props.children}
    </MenuItem>
  );
};

export default BaseSelectItem;
